import React, { Component } from 'react';
import { Typo, Buttons } from 'tmt-ui-kit';
import styled from 'styled-components';

const ContentContainer = styled.div`
  margin-top: 72px;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  div {
    >p {
      margin:12px auto 16px;
    }
  }
`;
const Title = styled(Typo.HeaderTwo)`
  margin: 0px;
`;
const Text = styled(Typo.Paragraph)`
  width: ${props => (props.bottom ? '80%' : '95%')};
`;
const Button = styled(Buttons.Button.BlueButton)`
  width: 168px;
  >a {
    color: ${props => props.theme.white};
  }
`;

class ContactUs extends Component {
  render() {
    return (
      <ContentContainer>
        <div>
          <Title>Can’t find your answer?</Title>
          <Text bottom>Get in touch with us and we’ll get back to you as soon as possible</Text>
          <Button><a href="mailto:support@takemetour.com">Contact Us</a></Button>
        </div>
      </ContentContainer>
    );
  }
}

export default ContactUs;
